import { render, staticRenderFns } from "./betbuilder_slide.vue?vue&type=template&id=6eaa2576&"
import script from "./betbuilder_slide.vue?vue&type=script&lang=js&"
export * from "./betbuilder_slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SportIcon: require('/var/web/bet777.es/components/sport/icon.vue').default,BetbuilderPrecannedBtn: require('/var/web/bet777.es/components/betbuilder/precanned_btn.vue').default})
